import { api } from '@/http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import type { MfaStatusResponse } from '@eye-able/types';
import { useQuery } from '@tanstack/react-query';

/** Which second factors the signed-in user holds. */
export function useFetchMfaStatus({ enabled = true } = {}) {
  return useQuery({
    enabled,
    queryKey: [api.mfa],
    queryFn: () => fetchWrapper.get<MfaStatusResponse>(api.mfa),
  });
}
